module.exports = __webpack_public_path__ + "src/assets/images/icon-tab-close.png?5e0e5b9b769522adca32bb6b94c61559";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-tab-close.png
// module id = 1009
// module chunks = 1